import { signIn } from "next-auth/react";
import classNames from "classnames";
import { GoogleIconSVG } from "../svg";

export default function GoogleSignInButton({ callbackUrl }) {
  return (
    <button
      onClick={() => {
        signIn("google", { callbackUrl });
      }}
      className={classNames(
        "group flex space-x-5 px-8 sm:px=12 lg:px-16 py-3 items-center",
        "bg-white border border-gray-1 rounded-xl shadow-md",
        "hover:bg-gray-1 focus:ring-2 focus:ring-gray-200"
      )}
    >
      <GoogleIconSVG className={"w-6 h-auto"} />
      <span className="font-medium text-subheading-gray group-hover:text-black">
        Sign in with Google
      </span>
    </button>
  );
}
